var React = require('react');

function DoubleChevron (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#989898;}")),React.createElement("path",{"className":"a","d":"M3.07,187.148.843,189.374,0,188.531l3.07-3.07,3.07,3.07-.843.843Zm0,0","transform":"translate(0 -185.461)","key":1}),React.createElement("path",{"className":"a","d":"M6.14,3.57,5.3,4.413,3.07,2.187.843,4.413,0,3.57,3.07.5Zm0,0","transform":"translate(0 3.114)","key":2})]);
}

DoubleChevron.defaultProps = {"width":"6.14","height":"7.527","viewBox":"0 0 6.14 7.527"};

module.exports = DoubleChevron;

DoubleChevron.default = DoubleChevron;
